import React from "react"
import ErrorPopup from "../../../../../../../CommonComponents/ErrorPopup/ErrorPopup";
import {
    Types,
    AlertContent
  } from "../../../../../../../CommonComponents/ContentMessages";
import { AlertWrap } from "../../../style";

export const ErrorModal = ({showModal,cancelModal,decimalError = false})=>(


    <ErrorPopup
    title={
      <AlertContent
        page={"Recommend a Grant"}
        type={[Types.PAGE_ALERTS]}
        keyProperty={"Schedule Limit Recommend a Grant"}
        property={"field_header"}
        html={true}
        defaultMessage={"Error"}
        alertId="scheduleLimitTitle"
      />
    }
    show={showModal}
    primaryCta={cancelModal}
    primaryCtaLabel={
      <AlertContent
        page={"Recommend a Grant"}
        type={[Types.PAGE_ALERTS]}
        keyProperty={"Schedule Limit Recommend a Grant"}
        property={"field_alert_button1_text"}
        html={true}
        defaultMessage={"Ok"}
        alertId="scheduleLimitPrimaryBtn"
      />
    }
  >
    <AlertWrap>
      {
        decimalError?

      <AlertContent
        page={"Recommend a Grant"}
        type={[Types.PAGE_ALERTS]}
        keyProperty={"decimal alert"}
        property={"field_description"}
        html={true}
        defaultMessage={"<p>Decimals cannot be used in the percentage field.  Please update to whole percentages.</p>"}
        alertId="decimalAlert"
      />
      :
      <AlertContent
      page={"Recommend a Grant"}
      type={[Types.PAGE_ALERTS]}
      keyProperty={"Schedule Limit Recommend a Grant"}
      property={"field_description"}
      html={true}
      defaultMessage={"<p>Total grant percentage has to equal 100% </p>"}
      alertId="scheduleLimitDesc"
    />
      }
    </AlertWrap>
  </ErrorPopup>

)